import { Link } from "react-router-dom";
import NewsletterSignup from "./NewsletterSignup";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-32 py-12" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full overflow-hidden bg-[#FDF0CA]"><img src="/logo192.png" alt="Christoreel" className="h-8 w-8 object-cover" /></span>
            <span className="font-display text-xl font-black">Christo<span className="text-[#E65F2B]">reel</span></span>
          </div>
          <p className="text-sm text-white/60 max-w-sm leading-relaxed mb-4">
            A streaming home for African Christian cinema. Built to honor the storytellers who carry the Light.
          </p>
          <p className="text-eyebrow mb-2">Newsletter · faith-filled cinema in your inbox</p>
          <NewsletterSignup source="footer" variant="compact" />
        </div>
        <div>
          <p className="text-eyebrow mb-3">Platform</p>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/browse" className="hover:text-white transition">Browse</Link></li>
            <li><Link to="/subscription" className="hover:text-white transition">Membership</Link></li>
            <li><Link to="/newsletter" className="hover:text-white transition" data-testid="footer-link-newsletter">Newsletter</Link></li>
            <li><Link to="/register" className="hover:text-white transition">Become a Creator</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-eyebrow mb-3">Company</p>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/about" className="hover:text-white transition" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/submission-guidelines" className="hover:text-white transition" data-testid="footer-link-submission">Submission Guidelines</Link></li>
            <li><Link to="/how-payouts-work" className="hover:text-white transition" data-testid="footer-link-payouts">How creators get paid</Link></li>
            <li><Link to="/press" className="hover:text-white transition" data-testid="footer-link-press">Press &amp; Brand</Link></li>
            <li><Link to="/contact" className="hover:text-white transition" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mt-12 pt-6 border-t border-white/5 text-xs text-white/30 flex justify-between">
        <span>© {new Date().getFullYear()} Christoreel. Made with reverence.</span>
        <span>Naira-first. African-led.</span>
      </div>
    </footer>
  );
}
